module.exports = __webpack_public_path__ + "img/dash-VARILUX-E-SERIES_full_white.9d5a4854.png";